// extracted by mini-css-extract-plugin
export default {"Startup":"Startup_Startup__BYKiN","slogan":"Startup_slogan__qnBok","controls":"Startup_controls__OPvpK"};